import { ISnListResponse } from '@lib/api';
import { SnHttpResponseFilter } from '@lib/ui/filter';

import { SnAudit } from './audit';

export interface ISnAuditListResponse extends ISnListResponse<SnAudit> {
  filters: SnHttpResponseFilter[];
}
